const main = () => {
  const state = {
    // the menu item
    node: null,
    // the actual a tag for the menu item
    link: null,
    // the node's submenu
    menu: null,
    // the carrot icon
    icon: null,
    // callback to be invoked when current menu item should be closed
    cb: null,
  };

  // set up the click away listener, will be called for all click events that bubble up to the document.
  // If the event's target isn't contained within the state's current node (if it has one), then the
  // state's callback (cb) will be invoked and the current menu item will be hidden.
  document.addEventListener('click', (ev) => {
    // if the state has a node and the event's target isn't within that node
    // then the state's callback should be invoked
    if (state.node && !state.node.contains(ev.target) && state.cb) {
      state.cb();
    }
  });

  // setup the click logic on the specified node
  const bootstrapNavItem = (node) => {
    // only modify the menu's logic if it has children
    if (node.classList.contains('menu-item-has-children')) {
      const link = node.querySelector('a');
      const subMenu = node.querySelector('ul.sub-menu');
      const icon = link.querySelector('div.caret-wrap');

      // if the node doesn't have the link or subMenu, it's likely that this function was called
      // with an invalid node.
      if (!link || !subMenu) {
        return;
      }

      // if the link has children it shouldn't have an href other than #
      link.href = '#';

      const handleMenuEv = () => {
        // if the same element is clicked, close it and remove it from the document's active element
        if (state.node === node) {
          state.cb();
          if (document.activeElement) {
            document.activeElement.blur();
          }
          return;
        }

        // if the state's node isn't equal to the node associated with this link, run the logic for
        // closing an existing menu item (if open) + open the target menu item
        if (typeof state.cb === 'function') {
          state.cb();
        }

        state.node = node;
        state.link = link;
        state.menu = subMenu;
        state.icon = icon;

        // setup the callback to run on on click away or different menu item being opened
        state.cb = () => {
          state.cb = null;

          state.menu.classList.remove('dropdown-open');
          state.icon.classList.remove('dropdown-open');
          state.menu.style.visibility = null;
          state.menu.style.opacity = null;
          state.menu.style.display = null;

          state.node = null;
          state.link = null;
          state.menu = null;
          state.icon = null;
        };

        state.menu.classList.add('dropdown-open');
        state.icon.classList.add('dropdown-open');

        state.menu.style.visibility = 'visible';
        state.menu.style.opacity = 1;
        state.menu.style.display = 'block';
      };

      // we need to prevent the theme's default click functionality for the icon, otherwise our
      // state won't be in sync with the UI
      icon.addEventListener('click', (ev) => {
        ev.preventDefault();
        ev.stopPropagation();

        handleMenuEv();
      });

      link.addEventListener('click', (ev) => {
        ev.preventDefault();
        // need to stop the propagation or the click away listener will run and prematurely hide the
        // opened menu item
        ev.stopPropagation();

        handleMenuEv();
      });
    }
  };

  // setup the nav logic on the primary/desktop navigation
  const mainNav = document.querySelector('#nv-primary-navigation-main');
  if (mainNav) {
    Array.from(mainNav.children).forEach((node) => bootstrapNavItem(node));
  }

  // setup the nav logic on the secondary/mobile navigation
  const mobileNav = document.querySelector('#nv-primary-navigation-sidebar');
  if (mobileNav) {
    Array.from(mobileNav.children).forEach((node) => bootstrapNavItem(node));
  }
};

window.addEventListener('load', main);
